import { boxApply1qmzdb3dh90hg as boxApply } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.fa5_1 = this;
        this.ga5_1 = this;
        this.ha5_1 = false;
      }
      ia5(node, permissionsBitmask) {
        var prev = this.ga5_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.bah_1 & permissionsBitmask) === 0 && prev.ia5(node, permissionsBitmask));
        } else {
          node.fa5_1 = this;
          node.ga5_1 = prev;
          prev.fa5_1 = node;
          this.ga5_1 = node;
          tmp = true;
        }
        return tmp;
      }
      maa(forbiddenElementsBit) {
        this.ia5(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      ja5() {
        if (this.ha5_1)
          return false;
        var prev = this.ga5_1;
        var next = this.fa5_1;
        prev.fa5_1 = next;
        next.ga5_1 = prev;
        this.ha5_1 = true;
        return true;
      }
      ka5(node) {
        if (!(this.fa5_1 === this))
          return false;
        this.ia5(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.bah_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
